import { render, staticRenderFns } from "./rk-popper.vue?vue&type=template&id=f57d89ae&"
import script from "./rk-popper.vue?vue&type=script&lang=js&"
export * from "./rk-popper.vue?vue&type=script&lang=js&"
import style0 from "./rk-popper.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports